import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBad = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 48.6587,
			cy: 42.4495,
			r: 8.44969,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 79.0766,
			cy: 42.4495,
			r: 8.44969,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M92.5977 94.4188C92.5977 78.5522 79.7353 65.6898 63.8687 65.6898C48.0022 65.6898 35.1398 78.5522 35.1398 94.4188L25.0001 94.4188C25.0001 72.9522 42.4022 55.5502 63.8687 55.5502C85.3353 55.5502 102.737 72.9522 102.737 94.4188L92.5977 94.4188Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgBad);
export default ForwardRef;
